<template>
    <transition name="fade">
        <row align="stretch" justify="center" v-if="show" class="relative">
            <div class="absolute h-full flex items-center z-10"
                 :style="{ left: innerWidth > 1680 ? '-70px' : '0' }"
                 v-if="!flickityOptions['prevNextButtons'] && customButtons && innerWidth < 1680"
            >
                <slot name="previous">
                    <btn :ripple="false" @click="previous()" icon>
                        <div class="h-5 w-5 flex items-center justify-center">
                            <icon color="primary"
                                  icon="arrow-left"
                            ></icon>
                        </div>
                    </btn>
                </slot>
            </div>
            <column cols="full">
                <flickity :options="flickityOptions" class="w-full" ref="flickity">
                    <slot></slot>
                </flickity>
            </column>
            <div class="absolute h-full flex items-center z-10"
                 :style="{ right: innerWidth > 1680 ? '-70px' : '0' }"
                 v-if="!flickityOptions['prevNextButtons'] && customButtons && innerWidth < 1680"
            >
                <slot name="next">
                    <btn :ripple="false" @click="next()" icon>
                        <div class="h-5 w-5 flex items-center justify-center">
                            <icon color="primary"
                                  icon="arrow-right"
                            ></icon>
                        </div>
                    </btn>
                </slot>
            </div>
        </row>
    </transition>
</template>

<script>
    export default {
        name: "TwCarousel",
        props: {
            options: {
                type: [Object, null],
                default: null
            },
            customButtons: {
                type: Boolean,
                default: false
            }
        },
        components: {
            'flickity': () => import('vue-flickity'),
            btn: () => import('@/components/Btn.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
        },
        data: () => ({
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: true,
                wrapAround: true,
                percentPosition: false,
                cellAlign: 'center'
            },
            page: 0,
            show: false,
            innerWidth: 0
        }),
        methods: {
            parseOptions() {
                if (this.options) {
                    Object.keys(this.flickityOptions).forEach((option) => {
                        if (this.options[option] !== undefined) {
                            this.$set(this.flickityOptions, option, this.options[option]);
                        }
                    });
                }
                this.$nextTick(() => {
                    this.show = true;
                });
            },
            next() {
                this.$refs.flickity.next();
                this.page++;
            },
            previous() {
                this.$refs.flickity.previous();
                this.page--;
            },
            reRender() {
                this.show = false;
                // setTimeout(() => {
                    this.parseOptions();
                    this.innerWidth = window.innerWidth;
                    this.show = true;
                // }, 1000);
            }
        },
        mounted() {
            this.parseOptions();
            this.innerWidth = window.innerWidth;
        }
    }
</script>

<style>
    .flickity-page-dots .dot {
        background: #0174EA !important;
    }

    .flickity-page-dots .dot.is-selected {
        background: #0174EA;
        box-shadow: 0 0 0 2px rgba(1, 116, 234, 0.3);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>